import { render, staticRenderFns } from "./ElementList.vue?vue&type=template&id=bc727838&scoped=true&"
import script from "./ElementList.vue?vue&type=script&lang=js&"
export * from "./ElementList.vue?vue&type=script&lang=js&"
import style0 from "./ElementList.vue?vue&type=style&index=0&id=bc727838&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc727838",
  null
  
)

export default component.exports